export default class ClientsPortfoliosIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = window.location.href.split('?')[0];
      let params = {};
      let status = $('#portfolios_table').attr('data-filters-status');
      if (typeof status !== 'undefined') {params['status'] = status.toLowerCase()}
      Turbo.visit(url + '?' + $.param(params));
    }

    // On filter select
    $('#search_portfolio_statuses').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      $('.tooltip').tooltip('hide');
      $('#portfolios_table').attr('data-filters-status', suggestion);
      reloadWithSelectedParams();
      $(this).blur();
    });

  }


}